import React, {useEffect, useState} from 'react';
import Aux from '../../hoc/Aux/Aux';
import ProjectListItemPlaceholder
    from '../../components/UI/Placeholder/ProjectListItemPlaceholder/ProjectListItemPlacholder';
import CallToActionPlaceholder from "../../components/UI/Placeholder/CallToActionPlaceholder/CallToActionPlaceholder";
import ProjectListItem from './ProjectListItem/ProjectListItem';
import CallToAction from '../../components/CallToAction/CallToAction';
import styles from './ProjectList.module.scss';
import axios from '../../axios-base';
import {NavLink, useHistory, useLocation} from 'react-router-dom';
import {Col, Row} from 'reactstrap';
import {faSearch} from '@fortawesome/free-solid-svg-icons';
import thumbnailPlaceholder from '../../assets/images/project-thumbnail-placeholder.webp';
import FormInput from '../../components/UI/Input/FormInput';
import {sendVirtualPageView} from '../../shared/utility';
import qs from 'qs';
import {Helmet} from "react-helmet";

const {determineVotes} = require('../../shared/VoteEvaluatorFunctions');

function ProjectListHook(props) {

    const [projects, setProjects] = useState(null);
    const [phrase, setPhrase] = useState('');
    const [categoryOptions, setCategoryOptions] = useState(null);
    const [categorySelected, setCategorySelected] = useState('');
    const [cta, setCta] = useState(null);
    const [inputSelection, setInputSelection] = useState(true);

    const location = useLocation();
    let history = useHistory();

    useEffect(() => {
        const cta = axios.get('/cta/', {params: {page: 'projekte'}})
        const options = axios.get('/options/')

        Promise.all([cta, options]).then(([resCta, resOptions]) => {
            setCta(resCta.data[0]);

            let availableCategories = resOptions.data[0].projectForm.projectCategory;
            if (availableCategories && availableCategories.elementConfig.options.length > 1) {
                let firstOption = () => {
                    if (availableCategories.dependent) {
                        return {value: "", displayValue: "Alle"}
                    } else {
                        return {
                            value: "",
                            displayValue: "Eine " + availableCategories.elementConfig.label + " wählen",
                            disabled: true
                        }
                    }
                }

                availableCategories.elementConfig.options.unshift(firstOption());
                availableCategories.elementConfig.label = "Teilnehmende nach " + availableCategories.elementConfig.label + " filtern";
                setCategoryOptions(availableCategories);
            }
        }).catch((error) => {
            console.log(error);
        });
        sendVirtualPageView("Teilnehmer");
    }, []);

    useEffect(() => {
        const query = qs.parse(location.search.slice(1)).category;
        setProjects(null);
        axios.get(`/projects/?category=${query}`)
            .then(response => {
                setProjects(response.data);
                setCategorySelected(query !== undefined ? query : "");
                setInputSelection(true);
                setCategorySelected(query !== undefined ? query : "");
                setInputSelection(true);
            })
            .catch(error => {
                console.log(error);
            });
    }, [location])

    const categoryHandler = (e) => {
        const selectedCategory = e.target.value;
        setPhrase('');
        setInputSelection(false);
        if (selectedCategory !== categorySelected) {
            setCategorySelected(selectedCategory);
            history.push({
                search: `?category=${selectedCategory}`
            });
        }
    };

    const onChangeHandler = (e) => {
        setPhrase(e.target.value);
        if (categorySelected !== '' && categoryOptions.dependent) {
            setCategorySelected('');
            history.push({
                search: `?category=`
            });
        }
    };

    let categoryForm;
    if (categoryOptions) {
        categoryForm = (<FormInput
                wrapperCSSClass='category-select mb-3'
                elementType={categoryOptions.elementType}
                elementConfig={categoryOptions.elementConfig}
                value={categorySelected}
                changed={(e) => categoryHandler(e)}
            disabled={!inputSelection}
            shouldValidate={categoryOptions.valid}
            helperText={`${categoryOptions.elementConfig.label}. Wie z.B. ${categoryOptions.elementConfig.options[1].displayValue} oder ${categoryOptions.elementConfig.options[2].displayValue}`}/>);
    }

    let projectsRender = (
        <Aux>
            <ProjectListItemPlaceholder/>
            <ProjectListItemPlaceholder/>
            <ProjectListItemPlaceholder/>
        </Aux>
    );

    if (projects && props.votingPhases) {
        projectsRender = projects
            .filter(project => (project.contestantName.toLowerCase() + " " + project.projectTitle.toLowerCase())
                .includes(phrase.toLowerCase()))
            .reduce((displayedProjects, project) => {
                let projectVoteCount = 0;
                let projectRank = '-';
                if (project) {
                    projectRank = project.rank;
                    projectVoteCount = determineVotes(project.voteCount, props.votingPhases);
                }

                let projectLink = (
                    // Todo: Deep-Link zur Ressource definieren und Pretty-Link erstellen
                    <Col className={`mb-4 d-flex`} key={project.id}>
                        <NavLink className={`h-100 ${styles.ProjectListLink} flex-grow-1`} to={'./' + project._id}>
                            <ProjectListItem
                                key={project._id}
                                achievements={project.achievements}
                                image={project.projectGallery.length ? project.projectGallery[0].url : thumbnailPlaceholder}
                                rank={projectRank}
                                name={project.contestantName}
                                title={project.projectTitle}
                                shortDescription={project.projectShortDescription}
                                voteCount={projectVoteCount}
                                imageSrc={project.projectGallery[0]}
                                projectBalance={project.fundingAccount.balance}
                                phases={props.votingPhases}
                                fundingStages={props.fundingStages}
                                aria-hidden={true}
                            >
                                {/* @Todo: Deep-Link zur Ressource definieren und Pretty-Link erstellen */}
                            </ProjectListItem>
                            <p className="visually-hidden">
                                {`${project.contestantName}${project.projectTitle ? " (" + project.projectTitle + ")" : ""} mit ${projectVoteCount} Stimmen: ${project.projectShortDescription}`}
                            </p>
                        </NavLink>
                    </Col>
                );
                displayedProjects.push(projectLink);
                return displayedProjects;
            }, []);
    }

    let ctaRender = <CallToActionPlaceholder/>;

    if (cta) {
        ctaRender = <CallToAction
            headline={cta.headline}
            copy={cta.copy}
            buttonText={cta.buttonText}
            buttonColor={cta.buttonColor}
            linkUrl={cta.linkUrl}
            outline={cta.outline}
            buttonVisibility={cta.buttonVisibility}
        />
    }

    return (
        <Aux>
            <Helmet>
                <title>{`${process.env.REACT_APP_PROJECT_TITLE}: Teilnehmer`}</title>
            </Helmet>

            {/* CallToAction */}
            <Row className="my-3">
                <Col>
                    {ctaRender}
                </Col>
            </Row>
        <Row className={styles.ProjectListCounterContainer + " bg-light pt-3 p-0 m-0 mb-3 border"}>
            {categoryForm}
                <Col className="mb-3 project-search">
                <FormInput disabled={!inputSelection}
                           changed={onChangeHandler}
                           inlineIcon={faSearch}
                           label="Teilnehmende suchen"
                           elementConfig={{
                               label: "Teilnehmende suchen", placeholder: "Musterverein e.V.", type: "search"
                           }}
                           elementType="search"
                           helperText="Freitextsuche nach einem Teilnehmenden"
                               value={phrase}/>
                </Col>
            </Row>
            <Row className="row-cols-1 row-cols-md-3">
                {projectsRender}
            </Row>
        </Aux>
    );

}

export default ProjectListHook;
